/**
 * @generated SignedSource<<1c48d11834c0577d7f638c245202ef3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveReservationLineInput = {
  assetTag: any;
  clientMutationId?: string | null | undefined;
  reservationId: string;
};
export type OpsReservationPageRemoveLineMutation$variables = {
  input: RemoveReservationLineInput;
};
export type OpsReservationPageRemoveLineMutation$data = {
  readonly removeReservationLine: {
    readonly reservation: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly assetTag: any | null | undefined;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsReservationPageRemoveLineMutation = {
  response: OpsReservationPageRemoveLineMutation$data;
  variables: OpsReservationPageRemoveLineMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveReservationLinePayload",
    "kind": "LinkedField",
    "name": "removeReservationLine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationPageRemoveLineMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationPageRemoveLineMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "025e35e75b0a25f23681950735ff49a7",
    "id": null,
    "metadata": {},
    "name": "OpsReservationPageRemoveLineMutation",
    "operationKind": "mutation",
    "text": "mutation OpsReservationPageRemoveLineMutation(\n  $input: RemoveReservationLineInput!\n) {\n  removeReservationLine(input: $input) {\n    reservation {\n      id\n    }\n    userErrors {\n      message\n      assetTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4304bd53d665ec05e7d92d3f4a311eb";

export default node;
